import type { ComponentProps } from 'react';
import {
  IdentifyFallback,
  RedirectToDashboardFallback,
  ShowLoginFallback,
} from './fallbacks';
import { Gate as GateComponent } from './gate';
import {
  embeddedAppRequiresAuthHook,
  hasAccessTokenGateHook,
  hasAdminRoleGateHook,
  hasFeatureGateHook,
  isAdminGateHook,
  isIdentified,
  isMerchant,
  isStandaloneGateHook,
  isSuperAdminGateHook,
} from './hooks';

export { useGate } from './gate';
export type { AdminRole } from './hooks';

export const Gate = (props: ComponentProps<typeof GateComponent>) => (
  <GateComponent {...props} />
);

Gate.fallbacks = {
  showLogin: ShowLoginFallback,
  identify: IdentifyFallback,
  redirectToDashboard: RedirectToDashboardFallback,
};

Gate.hooks = {
  hasAccessToken: hasAccessTokenGateHook,
  isAdmin: isAdminGateHook,
  isSuperAdmin: isSuperAdminGateHook,
  hasAdminRole: hasAdminRoleGateHook,
  hasFeature: hasFeatureGateHook,
  embeddedAppRequiresAuth: embeddedAppRequiresAuthHook,
  isStandalone: isStandaloneGateHook,
  isIdentified,
  isMerchant,
};
